/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * Zephyr
 * Zephyr API
 * OpenAPI spec version: 2.0
 */
export type GetEnvironmentVariableHistoryDefault = {
  entities: EnvironmentVariableHistoryDto[];
};

export type GetEnvironmentVariableHistoryPathParameters = {
  organization: string;
  project: string;
  application: string;
  environment: string;
};
export type GetEnvVarsByRemoteHost200 = { [key: string]: unknown };

export type GetEnvVarsByRemoteHostParams = {
  /**
   * The remote host to get the environment variables for
   */
  remote_host: string;
};

export type UnsetEnvironmentVariableDefault = {
  value: String;
};

export type UnsetEnvironmentVariablePathParameters = {
  organization: string;
  project: string;
  application: string;
  environment: string;
};
export type SetEnvironmentVariableDefault = {
  value: String;
};

export type SetEnvironmentVariablePathParameters = {
  organization: string;
  project: string;
  application: string;
  environment: string;
};
export type GetEnvironmentVariablesPathParameters = {
  organization: string;
  project: string;
  application: string;
  environment: string;
};
export type SetEnvironmentOrderDefault = {
  value: String;
};

export type SetEnvironmentOrderPathParameters = {
  organization: string;
  project: string;
  application: string;
};
export type DeleteEnvironmentVariableDefault = {
  value: String;
};

export type DeleteEnvironmentVariablePathParameters = {
  organization: string;
  project: string;
  application: string;
  id: string;
};
export type DeleteReleaseCandidateDefault = {
  value: String;
};

export type DeleteReleaseCandidatePathParameters = {
  organization: string;
  project: string;
  application: string;
  id: string;
};
export type DeployTagToEnvironmentPathParameters = {
  organization: string;
  project: string;
  application: string;
};
export type CreateReleaseCandidateDefault = {
  value: String;
};

export type CreateReleaseCandidatePathParameters = {
  organization: string;
  project: string;
  application: string;
};
export type GetReleasePipelineEnvironmentListPathParameters = {
  organization: string;
  project: string;
  application: string;
};
export type GetReleasePipelineTagListParams = {
  /**
   * The name to get the release pipeline tag for
   */
  name?: string;
  /**
   * The author id to get the release pipeline tag for
   */
  authorId?: string;
};

export type GetReleasePipelineTagListPathParameters = {
  organization: string;
  project: string;
  application: string;
};
export type GetReleasePipelineByApplicationListDefaultMeta = {
  currentPage?: number;
  lastPage?: number;
  next?: number;
  perPage?: number;
  prev?: number;
  total?: number;
};

export type GetReleasePipelineByApplicationListDefault = {
  entities?: ReleasePipelineItemDto[];
  meta?: GetReleasePipelineByApplicationListDefaultMeta;
};

export type GetReleasePipelineByApplicationListParams = {
  /**
   * The page number to get the release pipeline for
   */
  page: number;
  /**
   * The number of items per page to get the release pipeline for
   */
  perPage: number;
};

export type GetReleasePipelineByApplicationListPathParameters = {
  organization: string;
  project: string;
  application: string;
};
export type GetReleasePipelineByProjectListDefaultMeta = {
  currentPage?: number;
  lastPage?: number;
  next?: number;
  perPage?: number;
  prev?: number;
  total?: number;
};

export type GetReleasePipelineByProjectListDefault = {
  entities?: ReleasePipelineItemDto[];
  meta?: GetReleasePipelineByProjectListDefaultMeta;
};

export type GetReleasePipelineByProjectListParams = {
  application?: string;
  /**
   * The page number to get the release pipeline for
   */
  page: number;
  /**
   * The number of items per page to get the release pipeline for
   */
  perPage: number;
};

export type GetReleasePipelineByProjectListPathParameters = {
  organization: string;
  project: string;
};
export type GetReleasePipelineByOrgListDefaultMeta = {
  currentPage?: number;
  lastPage?: number;
  next?: number;
  perPage?: number;
  prev?: number;
  total?: number;
};

export type GetReleasePipelineByOrgListDefault = {
  entities?: ReleasePipelineItemDto[];
  meta?: GetReleasePipelineByOrgListDefaultMeta;
};

export type GetReleasePipelineByOrgListParams = {
  application?: string;
  project?: string;
  /**
   * The page number to get the release pipeline for
   */
  page: number;
  /**
   * The number of items per page to get the release pipeline for
   */
  perPage: number;
};

export type GetReleasePipelineByOrgListPathParameters = {
  organization: string;
};
export type InvitePeopleDefault = {
  value: PeopleDto;
};

export type InvitePeoplePathParameters = {
  organizationName: string;
};
export type CancelDowngradePathParameters = {
  organizationName: string;
};
export type ChangeSubscriptionPathParameters = {
  organizationName: string;
};
export type GetSubscriptionPathParameters = {
  organizationName: string;
};
export type GetStripeSubscriptionItemsPathParameters = {
  organizationName: string;
};
export type UpdateNonRecurringQuotaPathParameters = {
  organizationName: string;
  metric: NonRecurringSubscriptionMetric;
};
export type UpdateRecurringQuotaPathParameters = {
  organizationName: string;
  metric: RecurringSubscriptionMetric;
};
export type ListQuotasPathParameters = {
  organizationName: string;
};
export type GetDefaultPaymentMethod200 = StripePaymentMethodDto | null;

export type GetDefaultPaymentMethodPathParameters = {
  organizationName: string;
};
export type SetDefaultPaymentMethodParams = {
  paymentMethodId: string;
};

export type SetDefaultPaymentMethodPathParameters = {
  organizationName: string;
};
export type DetachPaymentMethodParams = {
  paymentMethodId: string;
};

export type DetachPaymentMethodPathParameters = {
  organizationName: string;
};
export type AttachPaymentMethodParams = {
  paymentMethodId: string;
  useAsDefault: boolean;
};

export type AttachPaymentMethodPathParameters = {
  organizationName: string;
};
export type ListPaymentMethodsParams = {
  ending_before?: string;
  limit?: number;
  starting_after?: string;
};

export type ListPaymentMethodsPathParameters = {
  organizationName: string;
};
export type GraphCurrentUsagePathParameters = {
  organizationName: string;
};
export type ListCurrentMetricUsagePathParameters = {
  organizationName: string;
  metric: SubscriptionMetric;
};
export type ListCurrentUsagePathParameters = {
  organizationName: string;
};
export type GetUpcomingInvoicePathParameters = {
  organizationName: string;
};
export type ListInvoicesParams = {
  ending_before?: string;
  limit?: number;
  starting_after?: string;
  status?: StripeInvoiceStatus;
};

export type ListInvoicesPathParameters = {
  organizationName: string;
};
export type GetCoupon200 = CouponDto | null;

export type GetCouponPathParameters = {
  coupon: string;
};
export interface UnsetEnvironmentVariableRequestDto {
  key: string;
}

export interface SetEnvironmentVariableRequestDto {
  isSecret?: boolean;
  key: string;
  value: string;
}

export interface EnvironmentVariableDto {
  isSecret?: boolean;
  key: string;
  value: string;
}

export interface DeployTagToEnvironmentRequestDto {
  environmentId: string;
  snapshotId: string;
  tagId: string;
}

export interface CreateReleaseCandidateRequestDto {
  environmentId: string;
  tagId: string;
}

export interface String {
  [key: string]: unknown;
}

export interface AuthorDto {
  id: string;
  name: string;
  /** @nullable */
  portrait?: string | null;
}

export interface EnvironmentVariableHistoryDto {
  action: string;
  createdAt: string;
  createdBy: AuthorDto;
  environmentId: string;
  id: string;
  key: string;
  new_value: string;
  old_value: string;
}

export interface DependencyVersionDto {
  branch?: string;
  commit?: string;
  createdAt: string;
  id: string;
  name: string;
  remote_host: string;
  snapshot_id: string;
  user: AuthorDto;
}

export interface ReleasePipelineEnvironmentDto {
  createdAt: string;
  id: string;
  modifiedAt?: string;
  name: string;
  order: number;
  releaseCandidates?: ReleaseCandidateDto[];
  version?: DependencyVersionDto;
}

export interface ReleasePipelineTagDto {
  available: boolean;
  id: string;
  modifiedAt?: string;
  name: string;
  remote_host: string;
  version?: DependencyVersionDto;
}

export interface ReleaseCandidateDto {
  application_uid: string;
  author?: string;
  createdAt?: string;
  environmentId: string;
  id: string;
  remote_host: string;
  tag: ReleasePipelineTagDto;
  version: DependencyVersionDto;
}

export interface ReleasePipelineItemDto {
  application: string;
  id: string;
  organization: string;
  project: string;
}

export interface SuppressionChangedDto {
  MessageStream: string;
  Recipient: string;
  SuppressSending: boolean;
}

export interface EntriPowerDomainRequestDto {
  applicationUrl: string;
  domain: string;
  powerRootPathAccess?: string[];
}

export interface EntriPowerDomainResponseDto {
  message: string;
}

/**
 * Is the domain already powered?
 */
export type EntriEligibleResponseDtoPowerStatus = { [key: string]: unknown };

export interface EntriEligibleResponseDto {
  /** Current cnameTarget value for the domain */
  applicationUrl: string;
  /** Current cnameTarget set on the Dashboard */
  cnameTarget: string;
  /** Is the domain CNAMEed to the cname_target of the application? */
  eligible: boolean;
  /** Paths with granted access to the root of the Application URL. [] | ["/path1", "/path2",..., "pathN"] */
  powerRootPathAccess: string[];
  /** Is the domain already powered? */
  powerStatus: EntriEligibleResponseDtoPowerStatus;
}

export interface EntriConnectUrlDtoEntriConnectUrlDto {
  link: string;
}

export type EntriConfigDtoDnsRecordsItem = { [key: string]: unknown };

export interface EntriConfigDto {
  applicationId: string;
  dnsRecords: EntriConfigDtoDnsRecordsItem[];
  token: string;
}

export interface NetlifySiteDto {
  customDomain?: string;
  defaultDomain?: string;
  id: string;
  name: string;
  url: string;
}

export interface CloudflareZoneDto {
  accountId: string;
  accountName: string;
  id: string;
  name: string;
  owner: string;
}

export type UpdateDeploymentIntegrationDtoIntegrationConfig = { [key: string]: unknown };

export interface UpdateDeploymentIntegrationDto {
  displayName?: string;
  integrationConfig?: UpdateDeploymentIntegrationDtoIntegrationConfig;
  isDefault?: boolean;
}

export interface UpdateWorkerDto {
  version: string;
}

export type CreateDeploymentIntegrationDtoType =
  (typeof CreateDeploymentIntegrationDtoType)[keyof typeof CreateDeploymentIntegrationDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateDeploymentIntegrationDtoType = {
  worker: 'worker',
  pages: 'pages',
} as const;

export type CreateDeploymentIntegrationDtoPlatform =
  (typeof CreateDeploymentIntegrationDtoPlatform)[keyof typeof CreateDeploymentIntegrationDtoPlatform];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateDeploymentIntegrationDtoPlatform = {
  cloudflare: 'cloudflare',
  aws: 'aws',
  netlify: 'netlify',
  azure: 'azure',
  gcp: 'gcp',
  fastly: 'fastly',
} as const;

export type CreateDeploymentIntegrationDtoIntegrationConfig = { [key: string]: unknown };

export interface CreateDeploymentIntegrationDto {
  displayName: string;
  integrationConfig: CreateDeploymentIntegrationDtoIntegrationConfig;
  isDefault: boolean;
  name: string;
  platform: CreateDeploymentIntegrationDtoPlatform;
  type: CreateDeploymentIntegrationDtoType;
}

export type DeploymentIntegrationDtoType =
  (typeof DeploymentIntegrationDtoType)[keyof typeof DeploymentIntegrationDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeploymentIntegrationDtoType = {
  worker: 'worker',
  pages: 'pages',
} as const;

export type DeploymentIntegrationDtoPlatform =
  (typeof DeploymentIntegrationDtoPlatform)[keyof typeof DeploymentIntegrationDtoPlatform];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeploymentIntegrationDtoPlatform = {
  cloudflare: 'cloudflare',
  aws: 'aws',
  netlify: 'netlify',
  azure: 'azure',
  gcp: 'gcp',
  fastly: 'fastly',
} as const;

export type DeploymentIntegrationDtoIntegrationConfig = { [key: string]: unknown };

export type DeploymentIntegrationDtoDeploymentConfig = { [key: string]: unknown };

export interface DeploymentIntegrationDto {
  createdAt: string;
  /** @nullable */
  deletedAt: string | null;
  deploymentConfig?: DeploymentIntegrationDtoDeploymentConfig;
  displayName: string;
  id: string;
  integrationConfig?: DeploymentIntegrationDtoIntegrationConfig;
  isDefault: boolean;
  isEnabled: boolean;
  name: string;
  organizationId: string;
  platform: DeploymentIntegrationDtoPlatform;
  type: DeploymentIntegrationDtoType;
  updatedAt: string;
  /** @nullable */
  workerVersionId: string | null;
}

export type SaveUserPinDtoType = { [key: string]: unknown };

export interface SaveUserPinDto {
  applicationId?: string;
  organizationId?: string;
  projectId?: string;
  type: SaveUserPinDtoType;
}

export interface SaveUserPinsDto {
  userPins: SaveUserPinDto[];
}

export type GetUserPinOptionDtoType = (typeof GetUserPinOptionDtoType)[keyof typeof GetUserPinOptionDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserPinOptionDtoType = {
  application: 'application',
  organization: 'organization',
  project: 'project',
} as const;

export interface GetUserPinOptionsDtoBasicInfo {
  displayName: string;
  id: string;
  name: string;
}

export interface GetUserPinOptionDto {
  application?: GetUserPinOptionsDtoBasicInfo;
  organization?: GetUserPinOptionsDtoBasicInfo;
  project?: GetUserPinOptionsDtoBasicInfo;
  type: GetUserPinOptionDtoType;
}

export type GetUserPinDtoVisibility = (typeof GetUserPinDtoVisibility)[keyof typeof GetUserPinDtoVisibility];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserPinDtoVisibility = {
  public: 'public',
  private: 'private',
} as const;

export type GetUserPinDtoType = (typeof GetUserPinDtoType)[keyof typeof GetUserPinDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserPinDtoType = {
  application: 'application',
  organization: 'organization',
  project: 'project',
} as const;

export interface Counters {
  applications?: number;
  remotes: number;
}

export interface BasicInfo {
  displayName: string;
  id: string;
  name: string;
}

export interface GetUserPinDto {
  application?: BasicInfo;
  cloudProvider: string;
  counters: Counters;
  description?: string;
  id: string;
  organization: BasicInfo;
  project?: BasicInfo;
  type: GetUserPinDtoType;
  visibility?: GetUserPinDtoVisibility;
}

export interface SidePanelResponse {
  name: string;
}

export type OrganizationPeopleDtoRole = { [key: string]: unknown };

export interface OrganizationPeopleDto {
  email: string;
  id: string;
  name: string;
  role: OrganizationPeopleDtoRole;
}

export type NewPeopleDtoRole = (typeof NewPeopleDtoRole)[keyof typeof NewPeopleDtoRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NewPeopleDtoRole = {
  viewer: 'viewer',
  editor: 'editor',
  admin: 'admin',
  owner: 'owner',
} as const;

export interface NewPeopleDto {
  email: string;
  name: string;
  role: NewPeopleDtoRole;
  username?: string;
}

export type PeopleDtoRole = { [key: string]: unknown };

export interface PeopleDto {
  email: string;
  id?: string;
  name: string;
  role: PeopleDtoRole;
}

export type UpdateMemberTeamRoleDtoRole =
  (typeof UpdateMemberTeamRoleDtoRole)[keyof typeof UpdateMemberTeamRoleDtoRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateMemberTeamRoleDtoRole = {
  maintainer: 'maintainer',
  member: 'member',
} as const;

export interface UpdateMemberTeamRoleDto {
  role: UpdateMemberTeamRoleDtoRole;
}

export type TeamUserDtoRole = { [key: string]: unknown };

export interface TeamUserDto {
  role: TeamUserDtoRole;
  teamId: string;
  userId: string;
}

export interface NewTeamMembersDto {
  membersIds: string[];
}

export interface UpdateTeamDto {
  /** @maxLength 30 */
  name: string;
}

export type TeamDetailsDtoAuthor = {
  id: string;
  name: string;
};

export interface TeamDetailsDto {
  author: TeamDetailsDtoAuthor;
  authorId: string;
  id: string;
  members: TeamMemberDto[];
  name: string;
  organizationId: string;
}

export type TeamMemberDtoUser = {
  email: string;
  id: string;
  lastAccess: string;
  name: string;
};

export type TeamMemberDtoRole = { [key: string]: unknown };

export interface TeamMemberDto {
  id: string;
  role: TeamMemberDtoRole;
  user: TeamMemberDtoUser;
}

export type OrganizationTeamDtoRole = (typeof OrganizationTeamDtoRole)[keyof typeof OrganizationTeamDtoRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationTeamDtoRole = {
  maintainer: 'maintainer',
  member: 'member',
} as const;

export type OrganizationTeamDtoAuthor = {
  id: string;
  name: string;
};

export interface OrganizationTeamDto {
  author: OrganizationTeamDtoAuthor;
  authorId: string;
  avatarColor: string;
  id: string;
  memberCount: number;
  name: string;
  role: OrganizationTeamDtoRole;
}

export interface NewTeamDto {
  /** @maxLength 30 */
  name: string;
}

export type TeamDtoRole = (typeof TeamDtoRole)[keyof typeof TeamDtoRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeamDtoRole = {
  maintainer: 'maintainer',
  member: 'member',
} as const;

export interface TeamDto {
  avatarColor: string;
  id: string;
  members: number;
  name: string;
  role: TeamDtoRole;
}

export interface UpdateProjectNameDto {
  name: string;
}

export interface UpdateProjectSettingsDto {
  description: string;
  displayName: string;
  isPrivate: boolean;
}

export interface ProjectSettingsDto {
  description: string;
  displayName: string;
  id: string;
  isPrivate: boolean;
  name: string;
}

export type UpdateProjectContributorDtoType = { [key: string]: unknown };

export type UpdateProjectContributorDtoRole = { [key: string]: unknown };

export interface UpdateProjectContributorDto {
  role: UpdateProjectContributorDtoRole;
  type: UpdateProjectContributorDtoType;
}

export type NewProjectContributorDtoType = { [key: string]: unknown };

export interface NewProjectContributorDto {
  /** @minItems 1 */
  ids: string[];
  type: NewProjectContributorDtoType;
}

export type ContributorDtoType = (typeof ContributorDtoType)[keyof typeof ContributorDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContributorDtoType = {
  member: 'member',
  team: 'team',
} as const;

export type ContributorDtoRole = { [key: string]: unknown };

export interface ContributorDto {
  avatarColor: string;
  email?: string;
  id: string;
  memberCount?: number;
  name: string;
  role: ContributorDtoRole;
  teamId?: string;
  type: ContributorDtoType;
  userId?: string;
  username?: string;
}

export type UpdateProjectDtoVisibility = { [key: string]: unknown };

export interface UpdateProjectDto {
  /**
   * @minLength 3
   * @maxLength 255
   */
  displayName?: string;
  /**
   * @minLength 3
   * @maxLength 255
   */
  name?: string;
  visibility?: UpdateProjectDtoVisibility;
}

export type OrganizationProjectDtoVisibility = { [key: string]: unknown };

export type OrganizationProjectDtoCounters = {
  applications?: number;
  remotes?: number;
};

export type OrganizationProjectDtoAuthor = {
  id: string;
  name: string;
};

export interface OrganizationProjectDto {
  applications: string[];
  author: OrganizationProjectDtoAuthor;
  authorId: string;
  contributors: UserProjectContributor;
  counters: OrganizationProjectDtoCounters;
  deletedAt: string;
  description?: string;
  displayName: string;
  hostPlatform: string;
  id: string;
  name: string;
  organizationId: string;
  pinned: boolean;
  tags: string[];
  updatedAt: string;
  visibility: OrganizationProjectDtoVisibility;
}

export type CreateProjectDtoVisibility = { [key: string]: unknown };

export interface CreateProjectDto {
  /** @maxLength 30 */
  displayName: string;
  /** @maxLength 255 */
  name: string;
  visibility: CreateProjectDtoVisibility;
}

export type ProjectDtoVisibility = { [key: string]: unknown };

export type ProjectDtoRole = { [key: string]: unknown };

export type ProjectDtoOrganization = {
  displayName: string;
  id: string;
  name: string;
};

export type ProjectDtoCounters = {
  applications?: number;
  remotes?: number;
};

export type ProjectDtoApplicationsItem = { [key: string]: unknown };

export interface ProjectDto {
  applications?: ProjectDtoApplicationsItem[];
  authorId: string;
  counters: ProjectDtoCounters;
  deletedAt: string;
  description: string;
  displayName: string;
  hostPlatform: string;
  id: string;
  metadata: string[];
  name: string;
  organization?: ProjectDtoOrganization;
  organizationId: string;
  role?: ProjectDtoRole;
  updatedAt: string;
  visibility: ProjectDtoVisibility;
}

export interface UpdateApplicationNameDto {
  name: string;
}

export interface UpdateApplicationSettingsDto {
  description: string;
  isPrivate: boolean;
}

export interface ApplicationSettingsDto {
  description: string;
  id: string;
  isPrivate: boolean;
  name: string;
}

export interface SetApplicationVersionUnavailableRequestDto {
  reason: string;
}

export interface SetApplicationVersionDeprecatedRequestDto {
  availableTill: string;
}

export type DeployVersionDtoDeployTarget =
  (typeof DeployVersionDtoDeployTarget)[keyof typeof DeployVersionDtoDeployTarget];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeployVersionDtoDeployTarget = {
  environment: 'environment',
  tag: 'tag',
  releaseCandidate: 'releaseCandidate',
} as const;

export interface DeployVersionDto {
  deployTarget: DeployVersionDtoDeployTarget;
  deployTargetId: string;
  id: string;
  snapshot_id: string;
}

export type DeployedVersionDtoDeployTarget =
  (typeof DeployedVersionDtoDeployTarget)[keyof typeof DeployedVersionDtoDeployTarget];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeployedVersionDtoDeployTarget = {
  environment: 'environment',
  tag: 'tag',
  releaseCandidate: 'releaseCandidate',
} as const;

export interface DeployedVersionDto {
  authorName: string;
  authorUserName: string;
  deployedAt: string;
  deployTarget: DeployedVersionDtoDeployTarget;
  deployTargetName: string;
  hostUrl: string;
  id: string;
  versionName: string;
}

export type ApplicationVersionDeployTargetDtoDeployTarget =
  (typeof ApplicationVersionDeployTargetDtoDeployTarget)[keyof typeof ApplicationVersionDeployTargetDtoDeployTarget];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApplicationVersionDeployTargetDtoDeployTarget = {
  environment: 'environment',
  tag: 'tag',
  releaseCandidate: 'releaseCandidate',
} as const;

export interface ApplicationVersionDeployTargetDto {
  deployTarget: ApplicationVersionDeployTargetDtoDeployTarget;
  id: string;
  name: string;
}

export interface ApplicationVersionDeployTargetResponse {
  envs: ApplicationVersionDeployTargetDto[];
  tags: ApplicationVersionDeployTargetDto[];
}

export type GetApplicationVersionDtoStatus = { [key: string]: unknown };

export type GetApplicationVersionDtoEnvironmentsItem = { [key: string]: unknown };

export type GetApplicationVersionDtoContext = {
  id?: string;
  name?: string;
};

export type GetApplicationVersionDtoAuthor = {
  email?: string;
  id?: string;
  name?: string;
};

export interface GetApplicationVersionDto {
  author: GetApplicationVersionDtoAuthor;
  branch: string;
  context: GetApplicationVersionDtoContext;
  downloads: number;
  environments: GetApplicationVersionDtoEnvironmentsItem[];
  id: string;
  published: string;
  remote_host: string;
  snapshot_id: string;
  status: GetApplicationVersionDtoStatus;
  statusDescription: string;
  version: string;
}

export interface UpdateApplicationEnvironmentDto {
  applicationVersionId?: string;
  condition?: ConditionDto;
  description?: string;
  name?: string;
  versionId?: string;
}

export interface EnvironmentConditionVersionDto {
  id: string;
  remote_host: string;
  version: string;
}

export interface EnvironmentConditionOptionsDto {
  tag: ConditionValueDto[];
  version: ConditionValueDto[];
}

export type ApplicationEnvironmentDtoContext = {
  id?: string;
  name?: string;
};

export type ApplicationEnvironmentDtoAuthor = {
  avatarColor?: string;
  email?: string;
  id?: string;
  name?: string;
  portrait?: string;
  username?: string;
};

export interface ApplicationEnvironmentVersionDto {
  id: string;
  name: string;
  /** @nullable */
  remote_entry_url: string | null;
  /** @nullable */
  remote_host: string | null;
}

export type ConditionDtoChannel = (typeof ConditionDtoChannel)[keyof typeof ConditionDtoChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConditionDtoChannel = {
  tag: 'tag',
  version: 'version',
} as const;

export interface ConditionValueDto {
  label: string;
  value: string;
}

export interface ConditionDto {
  channel: ConditionDtoChannel;
  value: ConditionValueDto;
}

export interface ApplicationEnvironmentDto {
  applicationId: string;
  applicationVersionId: string;
  author: ApplicationEnvironmentDtoAuthor;
  condition: ConditionDto;
  context?: ApplicationEnvironmentDtoContext;
  createdAt: string;
  customDnsNames: string[];
  deletedAt?: string;
  description?: string;
  id: string;
  name: string;
  remote_entry_url: string;
  remote_host: string;
  updatedAt?: string;
  version: ApplicationEnvironmentVersionDto;
}

export interface CreateApplicationEnvironmentDto {
  applicationVersionId: string;
  condition: ConditionDto;
  customDnsNames?: string[];
  description?: string;
  name: string;
  versionId: string;
}

export type UpdateApplicationTagDtoConditionsItem = { [key: string]: unknown };

export interface UpdateApplicationTagDto {
  applicationVersionId: string;
  conditions: UpdateApplicationTagDtoConditionsItem[];
  name: string;
}

export interface TagConditionVersionDto {
  id: string;
  remote_host: string;
  version: string;
}

export interface GetApplicationTagConditionOptionsDto {
  branch: string[];
  isCI: string[];
  target: string[];
  user: string[];
  version: string[];
}

export type ApplicationTagDtoVersion = {
  application_uid: string;
  id: string;
  name: string;
  /** @nullable */
  remote_entry_url: string | null;
  /** @nullable */
  remote_host: string | null;
};

export type ApplicationTagDtoContext = {
  id?: string;
  name?: string;
};

export type ApplicationTagDtoAuthor = {
  avatarColor?: string;
  email?: string;
  id?: string;
  name?: string;
  portrait?: string;
  username?: string;
};

export interface ApplicationTagDto {
  applicationVersionId: string;
  author: ApplicationTagDtoAuthor;
  conditions: ApplicationTagConditionDto[];
  context?: ApplicationTagDtoContext;
  createdAt?: string;
  deletedAt?: string;
  downloads?: number;
  id: string;
  name: string;
  publishedAt?: string;
  remote_entry_url: string;
  remote_host: string;
  updatedAt?: string;
  version?: ApplicationTagDtoVersion;
}

export interface CreateApplicationTagDto {
  applicationVersionId: string;
  conditions: ApplicationTagConditionDto[];
  name: string;
}

export type ApplicationTagConditionDtoType =
  (typeof ApplicationTagConditionDtoType)[keyof typeof ApplicationTagConditionDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApplicationTagConditionDtoType = {
  branch: 'branch',
  version: 'version',
  user: 'user',
  isCI: 'isCI',
  target: 'target',
} as const;

export interface ApplicationTagConditionValueDto {
  label: string;
  value: string;
}

export interface ApplicationTagConditionDto {
  type: ApplicationTagConditionDtoType;
  value: ApplicationTagConditionValueDto;
}

export interface ApplicationContributorDto {
  avatarColor: string;
  id: string;
  name: string;
}

export interface Consume {
  [key: string]: unknown;
}

export interface ApplicationDependenciesDto {
  dependedOnBy: ApplicationDependenciesDtoDependedOnBy;
  dependsOn: ApplicationDependenciesDtoDependsOn;
  selectedNode: ApplicationDependenciesDtoSelectedNode;
}

export type ApplicationDependenciesDtoSelectedNodeNodesItem = { [key: string]: unknown };

export type ApplicationDependenciesDtoSelectedNodeDependenciesItem = { [key: string]: unknown };

export type ApplicationDependenciesDtoSelectedNode = {
  dependencies: ApplicationDependenciesDtoSelectedNodeDependenciesItem[];
  nodes: ApplicationDependenciesDtoSelectedNodeNodesItem[];
};

export type ApplicationDependenciesDtoDependsOnNodesItem = { [key: string]: unknown };

export type ApplicationDependenciesDtoDependsOn = {
  nodes: ApplicationDependenciesDtoDependsOnNodesItem[];
};

export type ApplicationDependenciesDtoDependedOnByNodesItem = { [key: string]: unknown };

export type ApplicationDependenciesDtoDependedOnByDependenciesItem = { [key: string]: unknown };

export type ApplicationDependenciesDtoDependedOnBy = {
  dependencies: ApplicationDependenciesDtoDependedOnByDependenciesItem[];
  nodes: ApplicationDependenciesDtoDependedOnByNodesItem[];
};

export interface Version {
  [key: string]: unknown;
}

export interface ApplicationSettings {
  [key: string]: unknown;
}

export interface Override {
  [key: string]: unknown;
}

export interface Metadata {
  [key: string]: unknown;
}

export interface ApplicationModuleDto {
  applicationID: string;
  appVersion?: Version;
  consumedBy?: Consume[];
  file: string;
  id: string;
  metadata: Metadata[];
  name: string;
  platform: string;
  requires: string[];
  tags: string[];
}

export interface ApplicationDto {
  deletedAt: string;
  displayName: string;
  id: string;
  isPrivate?: boolean;
  metadata: Metadata[];
  name: string;
  overrides?: Override[];
  projectId: string;
  settings?: ApplicationSettings;
  tags: string[];
  updatedAt: string;
  versions: Version[];
}

export type ApplicationListByProjectItemDtoProjectVisibility = { [key: string]: unknown };

export type ApplicationListByProjectItemDtoProject = {
  displayName: string;
  id: string;
  name: string;
  visibility: ApplicationListByProjectItemDtoProjectVisibility;
};

export type ApplicationListByProjectItemDtoOrganization = {
  displayName: string;
  id: string;
  name: string;
};

export type ApplicationListByProjectItemDtoCounters = {
  remotes?: number;
};

export interface ApplicationListByProjectItemDto {
  contributors: Contributor[];
  counters: ApplicationListByProjectItemDtoCounters;
  deletedAt: string;
  description: string;
  hostPlatform: string;
  id: string;
  isPrivate: boolean;
  name: string;
  organization: ApplicationListByProjectItemDtoOrganization;
  project: ApplicationListByProjectItemDtoProject;
  tags: string[];
  updatedAt: string;
}

export type OrganizationApplicationDtoProjectVisibility = { [key: string]: unknown };

export type OrganizationApplicationDtoProject = {
  contributors: Contributor[];
  deletedAt: string;
  displayName: string;
  id: string;
  name: string;
  updatedAt: string;
  visibility: OrganizationApplicationDtoProjectVisibility;
};

export type OrganizationApplicationDtoOrganization = {
  displayName: string;
  id: string;
  name: string;
};

export type OrganizationApplicationDtoCounters = {
  remotes?: number;
};

export interface OrganizationApplicationDto {
  contributors: Contributor[];
  counters: OrganizationApplicationDtoCounters;
  deletedAt: string;
  description?: string;
  hostPlatform?: string;
  id: string;
  isPrivate: boolean;
  name: string;
  organization: OrganizationApplicationDtoOrganization;
  project: OrganizationApplicationDtoProject;
  tags?: string[];
  updatedAt: string;
}

export type UnPinNavigationBodyRequestType = { [key: string]: unknown };

export interface UnPinNavigationBodyRequest {
  id: string;
  type: UnPinNavigationBodyRequestType;
}

export type PinNavigationBodyRequestType = { [key: string]: unknown };

export interface PinNavigationBodyRequest {
  id: string;
  type: PinNavigationBodyRequestType;
}

export interface NavigationItemDto {
  id: string;
  isPinned: boolean;
  name: string;
}

export interface UpdateUserTokenNameReqDto {
  name: string;
}

export interface UpdateUserTokenReqDto {
  description?: string;
}

export interface CreateUserTokenReqDto {
  description?: string;
  expiryDays: number;
  name: string;
}

export interface UserAuthTokenDto {
  createdAt: string;
  /** @nullable */
  description: string | null;
  expiryAt: string;
  id: string;
  name: string;
  token: string;
  userId: string;
}

export interface UserProfileChangePasswordDto {
  newPassword: string;
  oldPassword: string;
}

export type UserProfileSettingsNotificationsActivityDtoValue =
  (typeof UserProfileSettingsNotificationsActivityDtoValue)[keyof typeof UserProfileSettingsNotificationsActivityDtoValue];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserProfileSettingsNotificationsActivityDtoValue = {
  Daily_Updates: 'Daily Updates',
  Weekly_Updates: 'Weekly Updates',
  Monthly_Updates: 'Monthly Updates',
  Quarterly_Updates: 'Quarterly Updates',
  Anual_Updates: 'Anual Updates',
} as const;

export interface UserProfileSettingsNotificationsActivityDto {
  label: string;
  receiveNotifications: boolean;
  value: UserProfileSettingsNotificationsActivityDtoValue;
}

export interface UserProfileSettingsEmailOptionsDto {
  additionalEmails: string[];
  defaultEmail: string;
  emailIsVerified: boolean;
  notificationsActivity?: UserProfileSettingsNotificationsActivityDto;
  privacyOptions: UserProfilePrivacyOptionsDto;
}

export interface UserProfileOwnedOrganizationDto {
  displayName: string;
  id: string;
  name: string;
}

export interface UserProfileLocationOptionsDto {
  location: string;
  locationVisible: boolean;
}

export interface UserProfilePrivacyOptionsDto {
  isPrivate: boolean;
}

export interface UpdateUserProfileSettingsEmailOptionsDto {
  additionalEmails?: string[];
  notificationsActivity?: UserProfileSettingsNotificationsActivityDto;
  privacyOptions?: UserProfilePrivacyOptionsDto;
}

export interface UserProfileUrlLinkDto {
  label: string;
  link: string;
}

export interface ProfileSettingsBodyReqDto {
  description?: string;
  email?: string;
  locationOptions?: UserProfileLocationOptionsDto;
  name?: string;
  privacyOptions?: UserProfilePrivacyOptionsDto;
  socialAccounts?: UserProfileUrlLinkDto[];
  username?: string;
  userPortrait?: string;
}

export interface ProfileSettingsDto {
  avatarColor: string;
  description?: string;
  email: string;
  emailIsVerified: boolean;
  id: string;
  locationOptions?: UserProfileLocationOptionsDto;
  name: string;
  ownedOrganizations: UserProfileOwnedOrganizationDto[];
  privacyOptions?: UserProfilePrivacyOptionsDto;
  socialAccounts?: UserProfileUrlLinkDto[];
  username: string;
  userPortrait?: string;
}

export type UpdateProfileResponseMetadata = { [key: string]: unknown };

export interface UpdateProfileResponse {
  createdAt: string;
  email: string;
  id: string;
  /** @nullable */
  lastAccess?: string | null;
  metadata: UpdateProfileResponseMetadata;
  name: string;
  /** @nullable */
  updatedAt?: string | null;
  username: string;
}

export interface UpdateProfileDto {
  description?: string;
  emails?: string[];
  /** @pattern /^[A-Za-z0-9\s\-."'@#_+]{3,255}$/ */
  name?: string;
  portrait?: string;
  removePortrait?: boolean;
  socialAccounts?: string[];
  /** @pattern /^[A-Za-z0-9\s\-."'@#_+]{3,255}$/ */
  username?: string;
}

export type EmailDataDtoRating = (typeof EmailDataDtoRating)[keyof typeof EmailDataDtoRating];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmailDataDtoRating = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
} as const;

export interface EmailDataDto {
  /** @maxLength 500 */
  message?: string;
  rating: EmailDataDtoRating;
}

export type UserApplicationListItemDtoProjectVisibility = { [key: string]: unknown };

export type UserApplicationListItemDtoOrganization = {
  displayName: string;
  id: string;
  name: string;
};

export type UserApplicationListItemDtoCounters = {
  remotes?: number;
};

export interface Contributor {
  avatarColor?: string;
  id: string;
  name: string;
  userId?: string;
  username?: string;
}

export type UserApplicationListItemDtoProject = {
  contributors: Contributor[];
  deletedAt: string;
  displayName: string;
  id: string;
  name: string;
  updatedAt: string;
  visibility: UserApplicationListItemDtoProjectVisibility;
};

export interface UserApplicationListItemDto {
  contributors: Contributor[];
  counters: UserApplicationListItemDtoCounters;
  deletedAt: string;
  description: string;
  hostPlatform: string;
  id: string;
  name: string;
  organization: UserApplicationListItemDtoOrganization;
  project: UserApplicationListItemDtoProject;
  tags: string[];
  updatedAt: string;
}

export type UserProjectListItemDtoVisibility = { [key: string]: unknown };

export type UserProjectListItemDtoOrganization = { [key: string]: unknown };

export type UserProjectListItemDtoCounters = {
  applications?: number;
  remotes?: number;
};

export type UserProjectListItemDtoAuthor = {
  id: string;
  name: string;
};

export type UserProjectListItemDtoApplications = { [key: string]: unknown };

export interface UserProjectContributor {
  [key: string]: unknown;
}

export interface UserProjectListItemDto {
  applications?: UserProjectListItemDtoApplications;
  author: UserProjectListItemDtoAuthor;
  authorId: string;
  contributors?: UserProjectContributor;
  counters: UserProjectListItemDtoCounters;
  deletedAt: string;
  description?: string;
  displayName: string;
  hostPlatform: string;
  id: string;
  name: string;
  organization: UserProjectListItemDtoOrganization;
  tags: string[];
  updatedAt: string;
  visibility: UserProjectListItemDtoVisibility;
}

export interface AvailableOrganizationDto {
  displayName: string;
  id: string;
  name: string;
}

export type UserDtoRole = (typeof UserDtoRole)[keyof typeof UserDtoRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserDtoRole = {
  viewer: 'viewer',
  editor: 'editor',
  admin: 'admin',
  owner: 'owner',
} as const;

export type UserDtoMetadata = { [key: string]: unknown };

export type UserDtoLocation = {
  city: string;
  country: string;
};

export interface UserDto {
  avatarColor?: string;
  company?: string;
  createdAt: string;
  /** @nullable */
  deletedAt: string | null;
  description?: string;
  email: string;
  emails?: string[];
  id: string;
  /** @nullable */
  lastAccess: string | null;
  location?: UserDtoLocation;
  metadata?: UserDtoMetadata;
  name: string;
  personalEmail?: string;
  /** @nullable */
  portrait: string | null;
  role?: UserDtoRole;
  socialAccounts?: string[];
  theme: string;
  /** @nullable */
  updatedAt: string | null;
  username?: string;
  webpage?: string;
}

export interface UpdateOrganizationDtoUpdateOrganizationDto {
  displayName?: string;
  domains?: string[];
  name?: string;
  openMembership?: boolean;
}

export interface CreateOrganizationDto {
  acceptedBy: string;
  displayName: string;
  name?: string;
}

export interface SubscriptionMetricOverages {
  /**
   * @minimum 0
   * @nullable
   */
  DEPLOYMENTS?: number | null;
}

export interface NonRecurringItemsAmounts {
  /** @minimum 1 */
  SEATS?: number;
}

export interface ChangeSubscriptionRequest {
  amounts?: NonRecurringItemsAmounts;
  coupon?: string;
  newBillingCycle: BillingCycle;
  newTier: SubscriptionTier;
  overages?: SubscriptionMetricOverages;
  stripePaymentMethodId?: string;
}

/**
 * @nullable
 */
export type SubscriptionWithQuotasAndCouponDtoScheduledTier = SubscriptionTier | null;

export type ScheduleReason = (typeof ScheduleReason)[keyof typeof ScheduleReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScheduleReason = {
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  MANUAL_DOWNGRADE: 'MANUAL_DOWNGRADE',
} as const;

/**
 * @nullable
 */
export type SubscriptionWithQuotasAndCouponDtoScheduleReason = ScheduleReason | null;

export type BillingCycle = (typeof BillingCycle)[keyof typeof BillingCycle];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BillingCycle = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
} as const;

export interface SubscriptionWithQuotasAndCouponDto {
  /** @nullable */
  cancelledAt?: string | null;
  coupon?: CouponDto;
  cycle: BillingCycle;
  id: string;
  lastInvoicedAt: string;
  nextBillingAt: string;
  organizationId: string;
  quotas: SimpleMetricQuotaDto[];
  /** @nullable */
  scheduledTier?: SubscriptionWithQuotasAndCouponDtoScheduledTier;
  /** @nullable */
  scheduleReason?: SubscriptionWithQuotasAndCouponDtoScheduleReason;
  startedAt: string;
  /** @nullable */
  stripeScheduleId?: string | null;
  stripeSubscriptionId: string;
  stripeTierPriceId: string;
  stripeTierProductId: string;
  stripeTierSubscriptionItemId: string;
  tier: SubscriptionTier;
}

export type StripeSubscriptionItemDtoTaxRatesItem = { [key: string]: unknown };

/**
 * @deprecated
 */
export type StripeSubscriptionItemDtoPlan = { [key: string]: unknown };

export type StripeSubscriptionItemDtoMetadata = { [key: string]: unknown };

export type StripeSubscriptionItemDtoDiscountsItemItem = { [key: string]: unknown };

/**
 * @nullable
 */
export type StripeSubscriptionItemDtoBillingThresholds = { [key: string]: unknown } | null;

export interface StripeSubscriptionItemDto {
  /** @nullable */
  billing_thresholds?: StripeSubscriptionItemDtoBillingThresholds;
  created: number;
  discounts: StripeSubscriptionItemDtoDiscountsItemItem[][];
  id: string;
  metadata?: StripeSubscriptionItemDtoMetadata;
  object: string;
  /** @deprecated */
  plan: StripeSubscriptionItemDtoPlan;
  price: StripePriceDto;
  quantity?: number;
  subscription: string;
  /** @nullable */
  tax_rates?: StripeSubscriptionItemDtoTaxRatesItem[] | null;
}

/**
 * @nullable
 */
export type StripePriceDtoTransformQuantity = StripePriceTransformQuantityDto | null;

/**
 * @nullable
 */
export type StripePriceDtoTiersMode = StripePriceTiersMode | null;

/**
 * @nullable
 */
export type StripePriceDtoTaxBehavior = StripePriceTaxBehavior | null;

/**
 * @nullable
 */
export type StripePriceDtoRecurring = StripePriceRecurringDto | null;

export type StripePriceDtoMetadata = { [key: string]: unknown };

export type StripePriceDtoCurrencyOptions = { [key: string]: unknown };

export type StripePriceType = (typeof StripePriceType)[keyof typeof StripePriceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StripePriceType = {
  one_time: 'one_time',
  recurring: 'recurring',
} as const;

export type StripePriceTransformQuantityRound =
  (typeof StripePriceTransformQuantityRound)[keyof typeof StripePriceTransformQuantityRound];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StripePriceTransformQuantityRound = {
  down: 'down',
  up: 'up',
} as const;

export interface StripePriceTransformQuantityDto {
  divide_by: number;
  round: StripePriceTransformQuantityRound;
}

export type StripePriceTiersMode = (typeof StripePriceTiersMode)[keyof typeof StripePriceTiersMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StripePriceTiersMode = {
  graduated: 'graduated',
  volume: 'volume',
} as const;

export interface StripePriceTierDto {
  /** @nullable */
  flat_amount?: number | null;
  /** @nullable */
  flat_amount_decimal?: string | null;
  /** @nullable */
  unit_amount?: number | null;
  /** @nullable */
  unit_amount_decimal?: string | null;
  /** @nullable */
  up_to?: number | null;
}

export interface StripePriceDto {
  active: boolean;
  billing_scheme: StripePriceBillingScheme;
  created: number;
  currency: string;
  currency_options?: StripePriceDtoCurrencyOptions;
  /** @nullable */
  custom_unit_amount?: StripePriceDtoCustomUnitAmount;
  id: string;
  livemode: boolean;
  /** @nullable */
  lookup_key?: string | null;
  metadata: StripePriceDtoMetadata;
  /** @nullable */
  nickname?: string | null;
  object: string;
  product: string;
  /** @nullable */
  recurring?: StripePriceDtoRecurring;
  /** @nullable */
  tax_behavior?: StripePriceDtoTaxBehavior;
  tiers?: StripePriceTierDto[];
  /** @nullable */
  tiers_mode?: StripePriceDtoTiersMode;
  /** @nullable */
  transform_quantity?: StripePriceDtoTransformQuantity;
  type: StripePriceType;
  /** @nullable */
  unit_amount?: number | null;
  /** @nullable */
  unit_amount_decimal?: string | null;
}

export type StripePriceTaxBehavior = (typeof StripePriceTaxBehavior)[keyof typeof StripePriceTaxBehavior];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StripePriceTaxBehavior = {
  inclusive: 'inclusive',
  exclusive: 'exclusive',
  unspecified: 'unspecified',
} as const;

export type StripePriceRecurringUsageType =
  (typeof StripePriceRecurringUsageType)[keyof typeof StripePriceRecurringUsageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StripePriceRecurringUsageType = {
  licensed: 'licensed',
  metered: 'metered',
} as const;

export type StripePriceRecurringInterval =
  (typeof StripePriceRecurringInterval)[keyof typeof StripePriceRecurringInterval];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StripePriceRecurringInterval = {
  day: 'day',
  month: 'month',
  week: 'week',
  year: 'year',
} as const;

export interface StripePriceRecurringDto {
  /** @nullable */
  aggregate_usage?: StripePriceRecurringDtoAggregateUsage;
  interval: StripePriceRecurringInterval;
  interval_count: number;
  /** @nullable */
  meter?: string | null;
  /** @nullable */
  trial_period_days?: number | null;
  usage_type?: StripePriceRecurringUsageType;
}

export type StripePriceRecurringAggregateUsage =
  (typeof StripePriceRecurringAggregateUsage)[keyof typeof StripePriceRecurringAggregateUsage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StripePriceRecurringAggregateUsage = {
  last_during_period: 'last_during_period',
  last_ever: 'last_ever',
  max: 'max',
  sum: 'sum',
} as const;

/**
 * @nullable
 */
export type StripePriceRecurringDtoAggregateUsage = StripePriceRecurringAggregateUsage | null;

export interface StripePriceCustomUnitAmountDto {
  /** @nullable */
  maximum?: number | null;
  /** @nullable */
  minimum?: number | null;
  /** @nullable */
  preset?: number | null;
}

/**
 * @nullable
 */
export type StripePriceDtoCustomUnitAmount = StripePriceCustomUnitAmountDto | null;

export type StripePriceBillingScheme = (typeof StripePriceBillingScheme)[keyof typeof StripePriceBillingScheme];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StripePriceBillingScheme = {
  per_unit: 'per_unit',
  tiered: 'tiered',
} as const;

export interface UpdateNonRecurringQuotaBody {
  coupon?: string;
  /** @minimum 1 */
  limit: number;
  stripePaymentMethodId?: string;
}

export type NonRecurringSubscriptionMetric =
  (typeof NonRecurringSubscriptionMetric)[keyof typeof NonRecurringSubscriptionMetric];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NonRecurringSubscriptionMetric = {
  SEATS: 'SEATS',
} as const;

export interface UpdateRecurringQuotaBody {
  /**
   * @minimum 0
   * @nullable
   */
  overage?: number | null;
}

export type RecurringSubscriptionMetric =
  (typeof RecurringSubscriptionMetric)[keyof typeof RecurringSubscriptionMetric];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecurringSubscriptionMetric = {
  DEPLOYMENTS: 'DEPLOYMENTS',
} as const;

export interface SimpleMetricQuotaDto {
  /** @nullable */
  limit?: number | null;
  metric: SubscriptionMetric;
  /** @nullable */
  overage?: number | null;
}

export type StripePaymentMethodDtoZip = { [key: string]: unknown };

export type StripePaymentMethodDtoWechatPay = { [key: string]: unknown };

export type StripePaymentMethodDtoUsBankAccount = { [key: string]: unknown };

export type StripePaymentMethodDtoTwint = { [key: string]: unknown };

export type StripePaymentMethodDtoSwish = { [key: string]: unknown };

export type StripePaymentMethodDtoSofort = { [key: string]: unknown };

export type StripePaymentMethodDtoSepaDebit = { [key: string]: unknown };

export type StripePaymentMethodDtoSamsungPay = { [key: string]: unknown };

export type StripePaymentMethodDtoRevolutPay = { [key: string]: unknown };

export type StripePaymentMethodDtoRadarOptions = { [key: string]: unknown };

export type StripePaymentMethodDtoPromptpay = { [key: string]: unknown };

export type StripePaymentMethodDtoPix = { [key: string]: unknown };

export type StripePaymentMethodDtoPaypal = { [key: string]: unknown };

export type StripePaymentMethodDtoPaynow = { [key: string]: unknown };

export type StripePaymentMethodDtoPayco = { [key: string]: unknown };

export type StripePaymentMethodDtoPayByBank = { [key: string]: unknown };

export type StripePaymentMethodDtoP24 = { [key: string]: unknown };

export type StripePaymentMethodDtoOxxo = { [key: string]: unknown };

export type StripePaymentMethodDtoNaverPay = { [key: string]: unknown };

export type StripePaymentMethodDtoMultibanco = { [key: string]: unknown };

export type StripePaymentMethodDtoMobilepay = { [key: string]: unknown };

/**
 * @nullable
 */
export type StripePaymentMethodDtoMetadata = { [key: string]: unknown } | null;

export type StripePaymentMethodDtoLink = { [key: string]: unknown };

export type StripePaymentMethodDtoKrCard = { [key: string]: unknown };

export type StripePaymentMethodDtoKonbini = { [key: string]: unknown };

export type StripePaymentMethodDtoKlarna = { [key: string]: unknown };

export type StripePaymentMethodDtoKakaoPay = { [key: string]: unknown };

export type StripePaymentMethodDtoInteracPresent = { [key: string]: unknown };

export type StripePaymentMethodDtoIdeal = { [key: string]: unknown };

export type StripePaymentMethodDtoGrabpay = { [key: string]: unknown };

export type StripePaymentMethodDtoGiropay = { [key: string]: unknown };

export type StripePaymentMethodDtoFpx = { [key: string]: unknown };

export type StripePaymentMethodDtoEps = { [key: string]: unknown };

export type StripePaymentMethodDtoCustomerBalance = { [key: string]: unknown };

export type StripePaymentMethodDtoCashapp = { [key: string]: unknown };

export type StripePaymentMethodDtoCardPresent = { [key: string]: unknown };

export type StripePaymentMethodDtoBoleto = { [key: string]: unknown };

export type StripePaymentMethodDtoBlik = { [key: string]: unknown };

export type StripePaymentMethodDtoBancontact = { [key: string]: unknown };

export type StripePaymentMethodDtoBacsDebit = { [key: string]: unknown };

export type StripePaymentMethodDtoAuBecsDebit = { [key: string]: unknown };

export type StripePaymentMethodDtoAmazonPay = { [key: string]: unknown };

export type StripePaymentMethodDtoAlma = { [key: string]: unknown };

export type StripePaymentMethodDtoAllowRedisplay = { [key: string]: unknown };

export type StripePaymentMethodDtoAlipay = { [key: string]: unknown };

export type StripePaymentMethodDtoAfterpayClearpay = { [key: string]: unknown };

export type StripePaymentMethodDtoAffirm = { [key: string]: unknown };

export type StripePaymentMethodDtoAcssDebit = { [key: string]: unknown };

export type StripePaymentMethodType = (typeof StripePaymentMethodType)[keyof typeof StripePaymentMethodType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StripePaymentMethodType = {
  card: 'card',
} as const;

export interface StripePaymentMethodDto {
  acss_debit?: StripePaymentMethodDtoAcssDebit;
  affirm?: StripePaymentMethodDtoAffirm;
  afterpay_clearpay?: StripePaymentMethodDtoAfterpayClearpay;
  alipay?: StripePaymentMethodDtoAlipay;
  allow_redisplay?: StripePaymentMethodDtoAllowRedisplay;
  alma?: StripePaymentMethodDtoAlma;
  amazon_pay?: StripePaymentMethodDtoAmazonPay;
  au_becs_debit?: StripePaymentMethodDtoAuBecsDebit;
  bacs_debit?: StripePaymentMethodDtoBacsDebit;
  bancontact?: StripePaymentMethodDtoBancontact;
  billing_details: StripeDtoBillingDetails;
  blik?: StripePaymentMethodDtoBlik;
  boleto?: StripePaymentMethodDtoBoleto;
  card?: StripePaymentMethodCardDto;
  card_present?: StripePaymentMethodDtoCardPresent;
  cashapp?: StripePaymentMethodDtoCashapp;
  created: number;
  customer?: string;
  customer_balance?: StripePaymentMethodDtoCustomerBalance;
  eps?: StripePaymentMethodDtoEps;
  fpx?: StripePaymentMethodDtoFpx;
  giropay?: StripePaymentMethodDtoGiropay;
  grabpay?: StripePaymentMethodDtoGrabpay;
  id: string;
  ideal?: StripePaymentMethodDtoIdeal;
  interac_present?: StripePaymentMethodDtoInteracPresent;
  kakao_pay?: StripePaymentMethodDtoKakaoPay;
  klarna?: StripePaymentMethodDtoKlarna;
  konbini?: StripePaymentMethodDtoKonbini;
  kr_card?: StripePaymentMethodDtoKrCard;
  link?: StripePaymentMethodDtoLink;
  livemode: boolean;
  /** @nullable */
  metadata?: StripePaymentMethodDtoMetadata;
  mobilepay?: StripePaymentMethodDtoMobilepay;
  multibanco?: StripePaymentMethodDtoMultibanco;
  naver_pay?: StripePaymentMethodDtoNaverPay;
  object: string;
  oxxo?: StripePaymentMethodDtoOxxo;
  p24?: StripePaymentMethodDtoP24;
  pay_by_bank?: StripePaymentMethodDtoPayByBank;
  payco?: StripePaymentMethodDtoPayco;
  paynow?: StripePaymentMethodDtoPaynow;
  paypal?: StripePaymentMethodDtoPaypal;
  pix?: StripePaymentMethodDtoPix;
  promptpay?: StripePaymentMethodDtoPromptpay;
  radar_options?: StripePaymentMethodDtoRadarOptions;
  revolut_pay?: StripePaymentMethodDtoRevolutPay;
  samsung_pay?: StripePaymentMethodDtoSamsungPay;
  sepa_debit?: StripePaymentMethodDtoSepaDebit;
  sofort?: StripePaymentMethodDtoSofort;
  swish?: StripePaymentMethodDtoSwish;
  twint?: StripePaymentMethodDtoTwint;
  type: StripePaymentMethodType;
  us_bank_account?: StripePaymentMethodDtoUsBankAccount;
  wechat_pay?: StripePaymentMethodDtoWechatPay;
  zip?: StripePaymentMethodDtoZip;
}

/**
 * @nullable
 */
export type StripePaymentMethodCardDtoWallet = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type StripePaymentMethodCardDtoThreeDSecureUsage = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type StripePaymentMethodCardDtoRegulatedStatus = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type StripePaymentMethodCardDtoNetworks = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type StripePaymentMethodCardDtoGeneratedFrom = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type StripePaymentMethodCardDtoChecks = { [key: string]: unknown } | null;

export interface StripePaymentMethodCardDto {
  brand: string;
  /** @nullable */
  checks?: StripePaymentMethodCardDtoChecks;
  /** @nullable */
  country?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  display_brand?: string | null;
  exp_month: number;
  exp_year: number;
  /** @nullable */
  fingerprint?: string | null;
  funding: string;
  /** @nullable */
  generated_from?: StripePaymentMethodCardDtoGeneratedFrom;
  /** @nullable */
  iin?: string | null;
  /** @nullable */
  issuer?: string | null;
  last4: string;
  /** @nullable */
  networks?: StripePaymentMethodCardDtoNetworks;
  /** @nullable */
  regulated_status?: StripePaymentMethodCardDtoRegulatedStatus;
  /** @nullable */
  three_d_secure_usage?: StripePaymentMethodCardDtoThreeDSecureUsage;
  /** @nullable */
  wallet?: StripePaymentMethodCardDtoWallet;
}

/**
 * @nullable
 */
export type StripeDtoBillingDetailsAddress = StripeAddressDto | null;

export interface StripeDtoBillingDetails {
  /** @nullable */
  address?: StripeDtoBillingDetailsAddress;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  phone?: string | null;
}

export type DbSpan = (typeof DbSpan)[keyof typeof DbSpan];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DbSpan = {
  hour: 'hour',
  day: 'day',
  week: 'week',
  month: 'month',
  year: 'year',
} as const;

export type RecurringSubscriptionMetricValues =
  (typeof RecurringSubscriptionMetricValues)[keyof typeof RecurringSubscriptionMetricValues];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecurringSubscriptionMetricValues = {
  DEPLOYMENTS: 'DEPLOYMENTS',
} as const;

export interface GraphMetricResultDto {
  /** @nullable */
  date?: string | null;
  metric: RecurringSubscriptionMetricValues;
  /** @nullable */
  used?: number | null;
}

export interface GraphMetricBodyDto {
  end?: string;
  /** @nullable */
  metrics?: RecurringSubscriptionMetricValues[] | null;
  span?: DbSpan;
  start?: string;
}

export interface UsageQuotaDto {
  /** @nullable */
  limit?: number | null;
  /** @nullable */
  overage?: number | null;
  /** @nullable */
  used?: number | null;
}

export type SubscriptionMetric = (typeof SubscriptionMetric)[keyof typeof SubscriptionMetric];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionMetric = {
  DEPLOYMENTS: 'DEPLOYMENTS',
  SEATS: 'SEATS',
} as const;

export interface UsagesQuotaDto {
  /** @nullable */
  limit?: number | null;
  metric: SubscriptionMetric;
  /** @nullable */
  overage?: number | null;
  /** @nullable */
  used?: number | null;
}

/**
 * @nullable
 */
export type StripeUpcomingInvoiceDtoTransferData = { [key: string]: unknown } | null;

export type StripeUpcomingInvoiceDtoTotalTaxAmountsItem = { [key: string]: unknown };

export type StripeUpcomingInvoiceDtoTotalPretaxCreditAmountsItem = { [key: string]: unknown };

export type StripeUpcomingInvoiceDtoTotalDiscountAmountsItem = { [key: string]: unknown };

export type StripeUpcomingInvoiceDtoThresholdReason = { [key: string]: unknown };

/**
 * @nullable
 */
export type StripeUpcomingInvoiceDtoSubscriptionDetails = { [key: string]: unknown } | null;

export type StripeUpcomingInvoiceDtoStatusTransitions = { [key: string]: unknown };

/**
 * @nullable
 */
export type StripeUpcomingInvoiceDtoStatus = StripeInvoiceStatus | null;

/**
 * @nullable
 */
export type StripeUpcomingInvoiceDtoShippingDetails = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type StripeUpcomingInvoiceDtoShippingCost = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type StripeUpcomingInvoiceDtoRendering = { [key: string]: unknown } | null;

export type StripeUpcomingInvoiceDtoPaymentSettings = { [key: string]: unknown };

/**
 * @nullable
 */
export type StripeUpcomingInvoiceDtoMetadata = { [key: string]: unknown } | null;

export type StripeUpcomingInvoiceDtoLines = { [key: string]: unknown };

/**
 * @nullable
 */
export type StripeUpcomingInvoiceDtoLastFinalizationError = { [key: string]: unknown } | null;

export type StripeUpcomingInvoiceDtoIssuer = { [key: string]: unknown };

/**
 * @nullable
 */
export type StripeUpcomingInvoiceDtoFromInvoice = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type StripeUpcomingInvoiceDtoDiscount = StripeDiscountDto | null;

export type StripeUpcomingInvoiceDtoDefaultTaxRatesItem = { [key: string]: unknown };

export type StripeUpcomingInvoiceDtoDefaultSource = { [key: string]: unknown };

export type StripeUpcomingInvoiceDtoDefaultPaymentMethod = { [key: string]: unknown };

export type StripeUpcomingInvoiceDtoCustomerTaxIdsItem = { [key: string]: unknown };

/**
 * @nullable
 */
export type StripeUpcomingInvoiceDtoCustomerTaxExempt = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type StripeUpcomingInvoiceDtoCustomerShipping = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type StripeUpcomingInvoiceDtoCustomerAddress = StripeAddressDto | null;

/**
 * @nullable
 */
export type StripeUpcomingInvoiceDtoCustomFields = StripeInvoiceCustomFieldDto | null;

export type StripeUpcomingInvoiceDtoCollectionMethod = { [key: string]: unknown };

/**
 * @nullable
 */
export type StripeUpcomingInvoiceDtoBillingReason = StripeInvoiceBillingReason | null;

export interface StripeUpcomingInvoiceDto {
  /** @nullable */
  account_country?: string | null;
  /** @nullable */
  account_name?: string | null;
  /** @nullable */
  account_tax_ids?: string[] | null;
  amount_due: number;
  amount_paid: number;
  amount_remaining: number;
  amount_shipping: number;
  application?: string;
  /** @nullable */
  application_fee_amount?: number | null;
  attempt_count: number;
  attempted: boolean;
  auto_advance?: boolean;
  automatic_tax: StripeInvoiceAutomaticTaxDto;
  /** @nullable */
  automatically_finalizes_at?: number | null;
  /** @nullable */
  billing_reason?: StripeUpcomingInvoiceDtoBillingReason;
  charge?: string;
  collection_method: StripeUpcomingInvoiceDtoCollectionMethod;
  created: number;
  currency: string;
  /** @nullable */
  custom_fields?: StripeUpcomingInvoiceDtoCustomFields;
  customer?: string;
  /** @nullable */
  customer_address?: StripeUpcomingInvoiceDtoCustomerAddress;
  /** @nullable */
  customer_email?: string | null;
  /** @nullable */
  customer_name?: string | null;
  /** @nullable */
  customer_phone?: string | null;
  /** @nullable */
  customer_shipping?: StripeUpcomingInvoiceDtoCustomerShipping;
  /** @nullable */
  customer_tax_exempt?: StripeUpcomingInvoiceDtoCustomerTaxExempt;
  /** @nullable */
  customer_tax_ids?: StripeUpcomingInvoiceDtoCustomerTaxIdsItem[] | null;
  default_payment_method?: StripeUpcomingInvoiceDtoDefaultPaymentMethod;
  default_source?: StripeUpcomingInvoiceDtoDefaultSource;
  default_tax_rates: StripeUpcomingInvoiceDtoDefaultTaxRatesItem[];
  /** @nullable */
  description?: string | null;
  /** @nullable */
  discount?: StripeUpcomingInvoiceDtoDiscount;
  discounts: StripeDiscountDto[];
  /** @nullable */
  due_date?: number | null;
  /** @nullable */
  effective_at?: number | null;
  /** @nullable */
  ending_balance?: number | null;
  /** @nullable */
  footer?: string | null;
  /** @nullable */
  from_invoice?: StripeUpcomingInvoiceDtoFromInvoice;
  /** @nullable */
  hosted_invoice_url?: string | null;
  /** @nullable */
  invoice_pdf?: string | null;
  issuer: StripeUpcomingInvoiceDtoIssuer;
  /** @nullable */
  last_finalization_error?: StripeUpcomingInvoiceDtoLastFinalizationError;
  latest_revision?: string;
  lines: StripeUpcomingInvoiceDtoLines;
  livemode: boolean;
  /** @nullable */
  metadata?: StripeUpcomingInvoiceDtoMetadata;
  /** @nullable */
  next_payment_attempt?: number | null;
  /** @nullable */
  number?: string | null;
  object: string;
  on_behalf_of?: string;
  paid: boolean;
  paid_out_of_band: boolean;
  payment_intent?: string;
  payment_settings: StripeUpcomingInvoiceDtoPaymentSettings;
  period_end: number;
  period_start: number;
  post_payment_credit_notes_amount: number;
  pre_payment_credit_notes_amount: number;
  quote?: string;
  /** @nullable */
  receipt_number?: string | null;
  /** @nullable */
  rendering?: StripeUpcomingInvoiceDtoRendering;
  /** @nullable */
  shipping_cost?: StripeUpcomingInvoiceDtoShippingCost;
  /** @nullable */
  shipping_details?: StripeUpcomingInvoiceDtoShippingDetails;
  starting_balance: number;
  /** @nullable */
  statement_descriptor?: string | null;
  /** @nullable */
  status?: StripeUpcomingInvoiceDtoStatus;
  status_transitions: StripeUpcomingInvoiceDtoStatusTransitions;
  subscription?: string;
  /** @nullable */
  subscription_details?: StripeUpcomingInvoiceDtoSubscriptionDetails;
  subscription_proration_date?: number;
  subtotal: number;
  /** @nullable */
  subtotal_excluding_tax?: number | null;
  /** @nullable */
  tax?: number | null;
  test_clock?: string;
  threshold_reason?: StripeUpcomingInvoiceDtoThresholdReason;
  total: number;
  /** @nullable */
  total_discount_amounts?: StripeUpcomingInvoiceDtoTotalDiscountAmountsItem[] | null;
  /** @nullable */
  total_excluding_tax?: number | null;
  /** @nullable */
  total_pretax_credit_amounts?: StripeUpcomingInvoiceDtoTotalPretaxCreditAmountsItem[] | null;
  total_tax_amounts?: StripeUpcomingInvoiceDtoTotalTaxAmountsItem[];
  /** @nullable */
  transfer_data?: StripeUpcomingInvoiceDtoTransferData;
  /** @nullable */
  webhooks_delivered_at?: number | null;
}

/**
 * @nullable
 */
export type StripeInvoiceDtoTransferData = { [key: string]: unknown } | null;

export type StripeInvoiceDtoTotalTaxAmountsItem = { [key: string]: unknown };

export type StripeInvoiceDtoTotalPretaxCreditAmountsItem = { [key: string]: unknown };

export type StripeInvoiceDtoTotalDiscountAmountsItem = { [key: string]: unknown };

export type StripeInvoiceDtoThresholdReason = { [key: string]: unknown };

/**
 * @nullable
 */
export type StripeInvoiceDtoSubscriptionDetails = { [key: string]: unknown } | null;

export type StripeInvoiceDtoStatusTransitions = { [key: string]: unknown };

/**
 * @nullable
 */
export type StripeInvoiceDtoStatus = StripeInvoiceStatus | null;

/**
 * @nullable
 */
export type StripeInvoiceDtoShippingDetails = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type StripeInvoiceDtoShippingCost = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type StripeInvoiceDtoRendering = { [key: string]: unknown } | null;

export type StripeInvoiceDtoPaymentSettings = { [key: string]: unknown };

/**
 * @nullable
 */
export type StripeInvoiceDtoMetadata = { [key: string]: unknown } | null;

export type StripeInvoiceDtoLines = { [key: string]: unknown };

/**
 * @nullable
 */
export type StripeInvoiceDtoLastFinalizationError = { [key: string]: unknown } | null;

export type StripeInvoiceDtoIssuer = { [key: string]: unknown };

/**
 * @nullable
 */
export type StripeInvoiceDtoFromInvoice = { [key: string]: unknown } | null;

export type StripeInvoiceDtoDefaultTaxRatesItem = { [key: string]: unknown };

export type StripeInvoiceDtoDefaultSource = { [key: string]: unknown };

export type StripeInvoiceDtoDefaultPaymentMethod = { [key: string]: unknown };

export type StripeInvoiceDtoCustomerTaxIdsItem = { [key: string]: unknown };

/**
 * @nullable
 */
export type StripeInvoiceDtoCustomerTaxExempt = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type StripeInvoiceDtoCustomerShipping = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type StripeInvoiceDtoCustomerAddress = StripeAddressDto | null;

/**
 * @nullable
 */
export type StripeInvoiceDtoCustomFields = StripeInvoiceCustomFieldDto | null;

export type StripeInvoiceDtoCollectionMethod = { [key: string]: unknown };

/**
 * @nullable
 */
export type StripeInvoiceDtoBillingReason = StripeInvoiceBillingReason | null;

export interface StripeInvoiceDto {
  /** @nullable */
  account_country?: string | null;
  /** @nullable */
  account_name?: string | null;
  /** @nullable */
  account_tax_ids?: string[] | null;
  amount_due: number;
  amount_paid: number;
  amount_remaining: number;
  amount_shipping: number;
  application?: string;
  /** @nullable */
  application_fee_amount?: number | null;
  attempt_count: number;
  attempted: boolean;
  auto_advance?: boolean;
  automatic_tax: StripeInvoiceAutomaticTaxDto;
  /** @nullable */
  automatically_finalizes_at?: number | null;
  /** @nullable */
  billing_reason?: StripeInvoiceDtoBillingReason;
  charge?: string;
  collection_method: StripeInvoiceDtoCollectionMethod;
  created: number;
  currency: string;
  /** @nullable */
  custom_fields?: StripeInvoiceDtoCustomFields;
  customer?: string;
  /** @nullable */
  customer_address?: StripeInvoiceDtoCustomerAddress;
  /** @nullable */
  customer_email?: string | null;
  /** @nullable */
  customer_name?: string | null;
  /** @nullable */
  customer_phone?: string | null;
  /** @nullable */
  customer_shipping?: StripeInvoiceDtoCustomerShipping;
  /** @nullable */
  customer_tax_exempt?: StripeInvoiceDtoCustomerTaxExempt;
  /** @nullable */
  customer_tax_ids?: StripeInvoiceDtoCustomerTaxIdsItem[] | null;
  default_payment_method?: StripeInvoiceDtoDefaultPaymentMethod;
  default_source?: StripeInvoiceDtoDefaultSource;
  default_tax_rates: StripeInvoiceDtoDefaultTaxRatesItem[];
  /** @nullable */
  description?: string | null;
  /** @nullable */
  discount?: StripeInvoiceDtoDiscount;
  discounts: StripeDiscountDto[];
  /** @nullable */
  due_date?: number | null;
  /** @nullable */
  effective_at?: number | null;
  /** @nullable */
  ending_balance?: number | null;
  /** @nullable */
  footer?: string | null;
  /** @nullable */
  from_invoice?: StripeInvoiceDtoFromInvoice;
  /** @nullable */
  hosted_invoice_url?: string | null;
  id: string;
  /** @nullable */
  invoice_pdf?: string | null;
  issuer: StripeInvoiceDtoIssuer;
  /** @nullable */
  last_finalization_error?: StripeInvoiceDtoLastFinalizationError;
  latest_revision?: string;
  lines: StripeInvoiceDtoLines;
  livemode: boolean;
  /** @nullable */
  metadata?: StripeInvoiceDtoMetadata;
  /** @nullable */
  next_payment_attempt?: number | null;
  /** @nullable */
  number?: string | null;
  object: string;
  on_behalf_of?: string;
  paid: boolean;
  paid_out_of_band: boolean;
  payment_intent?: string;
  payment_settings: StripeInvoiceDtoPaymentSettings;
  period_end: number;
  period_start: number;
  post_payment_credit_notes_amount: number;
  pre_payment_credit_notes_amount: number;
  quote?: string;
  /** @nullable */
  receipt_number?: string | null;
  /** @nullable */
  rendering?: StripeInvoiceDtoRendering;
  /** @nullable */
  shipping_cost?: StripeInvoiceDtoShippingCost;
  /** @nullable */
  shipping_details?: StripeInvoiceDtoShippingDetails;
  starting_balance: number;
  /** @nullable */
  statement_descriptor?: string | null;
  /** @nullable */
  status?: StripeInvoiceDtoStatus;
  status_transitions: StripeInvoiceDtoStatusTransitions;
  subscription?: string;
  /** @nullable */
  subscription_details?: StripeInvoiceDtoSubscriptionDetails;
  subscription_proration_date?: number;
  subtotal: number;
  /** @nullable */
  subtotal_excluding_tax?: number | null;
  /** @nullable */
  tax?: number | null;
  test_clock?: string;
  threshold_reason?: StripeInvoiceDtoThresholdReason;
  total: number;
  /** @nullable */
  total_discount_amounts?: StripeInvoiceDtoTotalDiscountAmountsItem[] | null;
  /** @nullable */
  total_excluding_tax?: number | null;
  /** @nullable */
  total_pretax_credit_amounts?: StripeInvoiceDtoTotalPretaxCreditAmountsItem[] | null;
  total_tax_amounts?: StripeInvoiceDtoTotalTaxAmountsItem[];
  /** @nullable */
  transfer_data?: StripeInvoiceDtoTransferData;
  /** @nullable */
  webhooks_delivered_at?: number | null;
}

/**
 * @nullable
 */
export type StripeCouponDtoMetadata = { [key: string]: unknown } | null;

export type StripeCouponDtoCurrencyOptions = { [key: string]: unknown };

export type StripeCouponDtoAppliesTo = { [key: string]: unknown };

export type StripeCouponDuration = (typeof StripeCouponDuration)[keyof typeof StripeCouponDuration];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StripeCouponDuration = {
  forever: 'forever',
  once: 'once',
  repeating: 'repeating',
} as const;

export interface StripeCouponDto {
  /** @nullable */
  amount_off?: number | null;
  applies_to?: StripeCouponDtoAppliesTo;
  created: number;
  /** @nullable */
  currency?: string | null;
  currency_options?: StripeCouponDtoCurrencyOptions;
  duration: StripeCouponDuration;
  /** @nullable */
  duration_in_months?: number | null;
  id: string;
  livemode: boolean;
  /** @nullable */
  max_redemptions?: number | null;
  /** @nullable */
  metadata?: StripeCouponDtoMetadata;
  /** @nullable */
  name?: string | null;
  object: string;
  /** @nullable */
  percent_off?: number | null;
  /** @nullable */
  redeem_by?: number | null;
  times_redeemed: number;
  valid: boolean;
}

export interface StripeDiscountDto {
  /** @nullable */
  checkout_session: string | null;
  coupon: StripeCouponDto;
  customer?: string;
  /** @nullable */
  end?: number | null;
  id: string;
  /** @nullable */
  invoice?: string | null;
  /** @nullable */
  invoice_item?: string | null;
  object: string;
  promotion_code?: string;
  start?: number;
  /** @nullable */
  subscription?: string | null;
  /** @nullable */
  subscription_item?: string | null;
}

/**
 * @nullable
 */
export type StripeInvoiceDtoDiscount = StripeDiscountDto | null;

export interface StripeAddressDto {
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  /** @nullable */
  line1?: string | null;
  /** @nullable */
  line2?: string | null;
  /** @nullable */
  postal_code?: string | null;
  /** @nullable */
  state?: string | null;
}

export interface StripeInvoiceCustomFieldDto {
  name: string;
  value: string;
}

export type StripeInvoiceBillingReason = (typeof StripeInvoiceBillingReason)[keyof typeof StripeInvoiceBillingReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StripeInvoiceBillingReason = {
  automatic_pending_invoice_item_invoice: 'automatic_pending_invoice_item_invoice',
  manual: 'manual',
  quote_accept: 'quote_accept',
  subscription: 'subscription',
  subscription_create: 'subscription_create',
  subscription_cycle: 'subscription_cycle',
  subscription_threshold: 'subscription_threshold',
  subscription_update: 'subscription_update',
  upcoming: 'upcoming',
} as const;

/**
 * @nullable
 */
export type StripeInvoiceAutomaticTaxDtoLiability = { [key: string]: unknown } | null;

export type StripeInvoiceAutomaticTaxStatus =
  (typeof StripeInvoiceAutomaticTaxStatus)[keyof typeof StripeInvoiceAutomaticTaxStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StripeInvoiceAutomaticTaxStatus = {
  complete: 'complete',
  failed: 'failed',
  requires_location_inputs: 'requires_location_inputs',
} as const;

/**
 * @nullable
 */
export type StripeInvoiceAutomaticTaxDtoStatus = StripeInvoiceAutomaticTaxStatus | null;

export type StripeInvoiceAutomaticTaxDisabledReason =
  (typeof StripeInvoiceAutomaticTaxDisabledReason)[keyof typeof StripeInvoiceAutomaticTaxDisabledReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StripeInvoiceAutomaticTaxDisabledReason = {
  finalization_requires_location_inputs: 'finalization_requires_location_inputs',
  finalization_system_error: 'finalization_system_error',
} as const;

/**
 * @nullable
 */
export type StripeInvoiceAutomaticTaxDtoDisabledReason = StripeInvoiceAutomaticTaxDisabledReason | null;

export interface StripeInvoiceAutomaticTaxDto {
  /** @nullable */
  disabled_reason?: StripeInvoiceAutomaticTaxDtoDisabledReason;
  enabled: boolean;
  /** @nullable */
  liability?: StripeInvoiceAutomaticTaxDtoLiability;
  /** @nullable */
  status?: StripeInvoiceAutomaticTaxDtoStatus;
}

export type StripeInvoiceStatus = (typeof StripeInvoiceStatus)[keyof typeof StripeInvoiceStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StripeInvoiceStatus = {
  draft: 'draft',
  open: 'open',
  paid: 'paid',
  uncollectible: 'uncollectible',
  void: 'void',
} as const;

export type SubscriptionTier = (typeof SubscriptionTier)[keyof typeof SubscriptionTier];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionTier = {
  PERSONAL: 'PERSONAL',
  PRO: 'PRO',
  ENTERPRISE: 'ENTERPRISE',
} as const;

export interface CouponDto {
  /** @nullable */
  amountOff?: number | null;
  blockedSeats?: boolean;
  forcedSeats?: number;
  forcedTier?: SubscriptionTier;
  /** @nullable */
  percentOff?: number | null;
  productIds?: string[];
  stripeCouponId: string;
}

export type OrganizationDtoDefaultRole = (typeof OrganizationDtoDefaultRole)[keyof typeof OrganizationDtoDefaultRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationDtoDefaultRole = {
  viewer: 'viewer',
  editor: 'editor',
  admin: 'admin',
  owner: 'owner',
} as const;

export interface OrganizationDto {
  createdAt: string;
  defaultRole: OrganizationDtoDefaultRole;
  /** @nullable */
  deletedAt?: string | null;
  displayName: string;
  domains: string[];
  id: string;
  name: string;
  openMembership: boolean;
  /** @nullable */
  stripeCustomerId?: string | null;
  /** @nullable */
  updatedAt?: string | null;
}
